import Choices from '@/components/inputs/choices';
import Config from '@/config';

export default {
  extends: Choices,

  props: {
    multiple: { type: Boolean, default: false },
    items: { type: Array, default: () => Config.get('CURRENCIES') },
    inline: { type: Boolean, default: true },
    itemValue: { type: String, default: 'value' },
  },
};
